// auth0 reducer
export const SHOW_SCIM_SETTINGS = 'show-scim-settings';
export const UPDATE_AUTH0_CONNECTION_DATA = 'update-auth0-connection-data';
export const UPDATE_AUTH0_SETUP_DATA = 'update-auth0-setup-data';
export const UPDATE_AUTH0_DOMAIN_LIST = 'update-auth0-domain-list';
export const SHOW_SSO_ERROR = 'show-sso-error';
export const TOGGLE_UPDATING = 'toggle-updating';

// checklist reducer
export const UPDATE_CHECKLIST = 'update-checklist';
export const UPDATE_CHECKLIST_ITEM = 'update-checklist-item';

// confirmation modal reducer
export const HIDE_CONFIRMATION_MODAL = 'hide-confirmation-modal';
export const SHOW_CONFIRMATION_MODAL = 'show-confirmation-modal';
export const UPDATE_CONFIRMATION_MODAL_MESSAGE =
  'update-confirmation-modal-message';

// search modal reducer
export const HIDE_SEARCH_MODAL = 'hide-search-modal';
export const SHOW_SEARCH_MODAL = 'show-search-modal';

// device reducer
export const UPDATE_CAN_RUN_EXTENSION = 'update-can-run-extension';
export const UPDATE_EXTENSION_INSTALLED = 'update-extension-installed';

// dialog prompt reducer
export const SHOW_DIALOG_PROMPT = 'show-dialog-prompt';
export const CLOSE_DIALOG_PROMPT = 'close-dialog-prompt';

// notification blocked prompt reducer
export const SHOW_NOTIFICATION_BLOCKED_PROMPT =
  'show-notification-blocked-prompt';
export const CLOSE_NOTIFICATION_BLOCKED_PROMPT =
  'close-notification-blocked-prompt';

// error bar reducer
export const CLOSE_ERROR_BAR = 'close-error-bar';
export const SHOW_ERROR_BAR = 'show-error-bar';

// header reducer
export const CLOSE_HEADER_DROPDOWNS = 'close-dropdowns';
export const SHOW_HEADER_DROPDOWN = 'show-dropdown';
export const TOGGLE_PEAKED = 'toggle-peaked';
export const TOGGLE_SIDEBAR = 'toggle-sidebar';
export const UPDATE_VIEW_TYPE = 'update-view-type';

export const VIDEO_DOWNLOADING = 'video-downloading';
export const VIDEO_DOWNLOADING_PROGRESS = 'video-downloading-progress';
export const VIDEO_DOWNLOADING_RESET = 'video-downloading-reset';

// integrations reducer
export const ERROR_INTEGRATION_SETTINGS = 'error-integration-settings';
export const ERROR_INTEGRATION_SUGGESTION = 'error-integration-suggestion';
export const RESET_INTEGRATION_SUGGESTION = 'reset-integration-suggestion';
export const SAVING_INTEGRATION_SETTINGS = 'saving-integration-settings';
export const SAVING_INTEGRATION_SUGGESTION = 'saving-integration-suggestion';
export const SUCCESS_INTEGRATION_SETTINGS = 'success-integration-settings';
export const SUCCESS_INTEGRATION_SUGGESTION = 'success-integration-suggestion';
export const UPDATE_COMPANY_RESULTS = 'update-company-results';
export const UPDATE_INTEGRATION_SETTINGS = 'update-integration-settings';

// notification-settings reducer
export const ERROR_NOTIFICATION_SETTINGS = 'error-notification-settings';
export const SAVING_NOTIFICATION_SETTINGS = 'saving-notification-settings';
export const SUCCESS_NOTIFICATION_SETTINGS = 'success-notification-settings';
export const UPDATE_NOTIFICATION_SETTINGS = 'update-notification-settings';
export const SET_SHOW_BLOCKED_NOTIFICATIONS_MODAL =
  'set-show-blocked-notifications-modal';

// status bar reducer
export const CLOSE_STATUS_BAR = 'close-status-bar';
export const SHOW_STATUS_BAR = 'show-status-bar';

// triggers reducer
export const UPDATE_TRIGGERS = 'update-triggers';

// trimming reducers
export const ENTER_TRIM_MODE = 'enter-trim-mode';
export const LEAVE_TRIM_MODE = 'leave-trim-mode';
export const UPDATE_CURRENT_TRIM_RANGE = 'update-current-trim-range';
export const UPDATE_SELECTED_TRIM_BOUND = 'update-selected-trim-bound';
export const UPDATE_SELECTED_TRIM_RANGE = 'update-selected-trim-range';
export const UPDATE_TRIM_NEW_CHANGES = 'update-trim-new-changes';
export const UPDATE_TRIM_ORIGINAL_RANGES = 'update-trim-original-ranges';
export const UPDATE_TRIM_RANGES = 'update-trim-ranges';
export const UPDATE_TRIM_REDO_STACK = 'update-trim-redo-stack';
export const UPDATE_TRIM_UNDO_STACK = 'update-trim-undo-stack';
export const SET_SENDING_NEW_TRIM = 'set-sending-new-trim';
export const UPDATE_PLAY_RANGES = 'update-play-ranges';

// user reducer
export const GET_USER_INFO = 'get-user-info';
export const LOGOUT_USER = 'logout-user';
export const UPDATE_USER_ERROR = 'update-user-error';
export const UPDATE_USER_INFO = 'update-user-info';
export const UPDATE_USER_NOT_LOGGED_IN = 'update-user-not-logged-in';
export const USER_HAS_UPDATED_BUTTON_TEXT = 'user-has-updated-button-text';
export const PATCHING_USER_INFO = 'patching-user-info';
export const SUCCESS_PATCH_USER_INFO = 'success-patch-user-info';
export const FAILED_PATCH_USER_INFO = 'failed-patch-user-info';
export const SUCCESS_PATCH_USER_PASSWORD = 'success-patch-user-password';
export const PASSWORD_VALIDATION = 'password-validation';
export const UPDATE_DEFAULT_WORKSPACE = 'update-default-workspace';
export const UPDATE_DELETION_PENDING = 'update-deletion-pending';

// videos dashboard reducer
export const ADD_NEW_FOLDER_FROM_MOVE_MODAL = 'add-new-folder-from-move-modal';
export const CLOSE_DASHBOARD_CARD_DROPDOWNS = 'close-dashboard-card-dropdowns';
export const DASHBOARD_INIT = 'dashboard-init';
export const DISCARD_RENAME_CARD = 'discard-rename-card';
export const FETCH_SHARED_ITEMS = 'fetch-shared-items';
export const FETCH_FAVORITES = 'fetch-favorites';
export const FETCH_FOLDERS = 'fetch-folders';
export const FETCH_HIERARCHY = 'fetch-hierarchy';
export const FETCH_TOP_LEVEL_FOLDERS = 'fetch-top-level-folders';
export const FETCH_VIDEOS = 'fetch-videos';
export const RENAME_CARD = 'rename-card';
export const RESET_VIDEOS = 'reset-videos';
export const RESTORE_FROM_PAST = 'restore-from-past';
export const SHOW_DASHBOARD_CARD_DROPDOWN = 'show-dashboard-card-dropdown';
export const UPDATE_ALL_RECENT_VIDEOS_FETCHED =
  'update-all-recent-videos-fetched';
export const UPDATE_ALL_VIDEOS_FETCHED = 'update-all-videos-fetched';
export const UPDATE_WELCOME_LOOMS_FETCHED = 'update-welcome-looms-fetched';
export const UPDATE_BREADCRUMBS = 'update-breadcrumbs';
export const UPDATE_CHECKED_ITEMS = 'update-checked-items';
export const UPDATE_CURRENT_FOLDER_INFO = 'update-current-folder-info';
export const UPDATE_DRAGGING_MULTIPLE = 'update-dragging-multiple';
export const UPDATE_DRAGGING_ITEMS = 'update-dragging-items';
export const UPDATE_FAVORITES = 'update-favorites';
export const UPDATE_FOLDER_CHANGES_PENDING = 'update-folder-changes-pending';
export const UPDATE_FOLDER_NAME = 'update_folder_name';
export const UPDATE_FOLDER_TO_MOVE_TO = 'update-folder-to-move-to';
export const UPDATE_FOLDERS = 'update-folders';
export const UPDATE_FOLDERS_ERROR = 'update-folders-error';
export const UPDATE_FOLDERS_HIERARCHY = 'update-folders-hierarchy';
export const UPDATE_HAS_FETCHED_RECENT_TEAM_VIDEOS =
  'update-has-fetched-recent-team-videos';
export const UPDATE_IS_ARCHIVED = 'update-is-archived';
export const UPDATE_IS_FAVORITE = 'update-is-favorite';
export const UPDATE_IS_JTBD = 'update-is-jtbd';
export const UPDATE_PAST = 'update-past';
export const UPDATE_RECENT_TEAM_VIDEOS = 'update-recent-team-videos';
export const UPDATE_SELECTED_SUB_HEADER = 'udpate-selected-sub-header';
export const UPDATE_SHOW_MOVE_MODAL = 'update-show-move-modal';
export const UPDATE_TOP_LEVEL_FOLDERS = 'update-top-level-folders';
export const UPDATE_TOTAL_VIDEO_COUNT = 'update-total-video-count';
export const UPDATE_USER_FAVORITE_FOLDER = 'udpate-user-favorite-folder';
export const UPDATE_USER_FAVORITE_VIDEO = 'udpate-user-favorite-video';
export const UPDATE_VIDEO_NAME = 'update-video-name';
export const UPDATE_VIDEOS = 'update-videos';
export const UPDATE_VIDEOS_ERROR = 'update-videos-error';
export const UPDATE_VIDEOS_GRID = 'update-videos-grid';
export const TOGGLE_DASHBOARD_UPGRADE_MODAL = 'toggle-darshboard-upgrade-modal';
export const UPDATE_SELECTED_WORKSPACE = 'update-selected-workspace';
export const TOGGLE_SIDEBAR_COLLAPSED = 'toggle-sidebar-collapsed';
export const UPDATE_IS_FAVORITES_PAGE = 'update-is-favorites-page';
export const UPDATE_IS_SHARED_WITH_ME_PAGE = 'update-is-shared-with-me-page';
export const REMOVE_FOLDERS = 'remove-folders';
export const REMOVE_VIDEOS = 'remove-videos';
export const CLEAR_CHECKED_ITEMS = 'clear-checked-items';
export const UPDATE_PAST_FOLDER_NAME = 'update-past-folder-name';
export const UPDATE_PAGE_TYPE = 'update-page-type';
export const UPDATE_WORKSPACE_LIBRARY_VIDEO_COUNTS =
  'update-workspace-library-video-counts';

export const UPDATE_WELCOME_LOOMS = 'update-welcome-loom';
export const UPDATE_WELCOME_PERSONA_TEXT = 'update-welcome-persona-text';

// move modal reducer
export const CLEAR_MOVE_MODAL_FOLDERS = 'clear-move-modal-folders';
export const UPDATE_FETCHING_MOVE_MODAL_TOP_LEVEL_FOLDER =
  'update-fetching-move-modal-top-level-folder';
export const UPDATE_MOVE_MODAL_FOLDERS = 'update-move-modal-folders';
export const UPDATE_MOVE_MODAL_TOP_LEVEL_FOLDER =
  'update-move-modal-top-level-folder';
export const MOVE_MODAL_CREATE_NEW_FOLDER_FAILED =
  'move-modal-create-new-folder-failed';
export const MOVE_MODAL_CREATE_NEW_FOLDER_HIDE =
  'move-modal-create-new-folder-hide';
export const MOVE_MODAL_CREATE_NEW_FOLDER_SHOW =
  'move-modal-create-new-folder-show';
export const MOVE_MODAL_CREATE_NEW_FOLDER_SUCCESS =
  'move-modal-create-new-folder-success';
export const MOVE_MODAL_UPDATE_FOLDER_TO_MOVE_TO =
  'move-modal-update-folder-to-move-to';
export const MOVE_MODAL_UPDATE_NEW_FOLDER_NAME =
  'move-modal-update-new-folder-name';
export const TOGGLE_MOVE_MODAL = 'toggle-move-modal';

// video player reducer
export const FETCH_VIDEO_PLAYER_VIDEO = 'fetch-video-player-video';
export const REQUEST_VIDEO_PLAYER_SEEKTO_TS = 'request-video-player-seekto-ts';
export const REQUEST_VIDEO_PLAYER_CURRENT_TIME =
  'request-video-player-current-time';
export const REQUEST_VIDEO_PLAYER_ENTER_FULL_SCREEN =
  'request-video-player-enter-full-screen';
export const REQUEST_VIDEO_PLAYER_LEAVE_FULL_SCREEN =
  'request-video-player-leave-full-screen';
export const REQUEST_VIDEO_PLAYER_MUTE = 'request-video-player-mute';
export const REQUEST_VIDEO_PLAYER_PAUSE = 'request-video-player-pause';
export const REQUEST_VIDEO_PLAYER_PLAY = 'request-video-player-play';
export const REQUEST_VIDEO_PLAYER_PLAYBACK_RATE =
  'request-video-player-playback-rate';
export const REQUEST_VIDEO_PLAYER_UNMUTE = 'request-video-player-unmute';
export const REQUEST_VIDEO_PLAYER_VOLUME = 'request-video-player-volume';
export const UPDATE_FROM_PUBLIC_SHARE_PAGE = 'update-from-public-share-page';
export const UPDATE_IS_INLINE_EMBED_ON_LOOM = 'update-is-inline-embed-on-loom';
export const UDPATE_IS_FROM_SLACK_DESKTOP_APP =
  'update-is-from-slack-desktop-app';
export const UPDATE_VIDEO_PLAYER_AUTOPLAY = 'update-video-player-auto-play';
export const UPDATE_VIDEO_PLAYER_BUFFERED_PARTS =
  'update-video-player-buffered-parts';
export const UPDATE_VIDEO_PLAYER_COMMENT_MARKERS =
  'update-video-player-comment-markers';
export const UPDATE_VIDEO_PLAYER_ACTIVE_COMMENT_BUCKET_INDEX =
  'update-video-player-active-comment-bucket-index';
export const UPDATE_VIDEO_PLAYER_HOVERED_COMMENT_BUCKET_INDEX =
  'update-video-player-hovered-comment-bucket-index';
export const UPDATE_VIDEO_PLAYER_CURRENT_TIME =
  'update-video-player-current-time';
export const UPDATE_VIDEO_PLAYER_DISPLAYED_DURATION =
  'update-video-player-displayed-duration';
export const UPDATE_VIDEO_PLAYER_TIME_OFFSET =
  'update-video-player-time-offset';
export const UPDATE_VIDEO_PLAYER_DIMENSIONS = 'update-video-player-dimensions';
export const UPDATE_VIDEO_PLAYER_DURATION = 'update-video-player-duration';
export const UPDATE_VIDEO_PLAYER_ENDED = 'update-video-player-ended';
export const UPDATE_VIDEO_PLAYER_NOT_ENDED = 'update-video-player-not-ended';
export const UPDATE_VIDEO_PLAYER_ENTER_FULL_SCREEN =
  'update-video-player-enter-full-screen';
export const UPDATE_VIDEO_PLAYER_FLIPPED_CAMERA =
  'update-video-player-flipped-camera';
export const UPDATE_VIDEO_PLAYER_FROM_LINK_EXPAND =
  'update-video-from-link-expand';
export const UPDATE_VIDEO_PLAYER_LEAVE_FULL_SCREEN =
  'update-video-player-leave-full-screen';
export const UPDATE_VIDEO_PLAYER_MOUSE_ACTIVE =
  'update-video-player-mouse-active';
export const UPDATE_VIDEO_PLAYER_MOUSE_INACTIVE =
  'update-video-player-mouse-inactive';
export const UPDATE_VIDEO_PLAYER_MUTE = 'update-video-player-mute';
export const UPDATE_VIDEO_PLAYER_NEEDS_PASSWORD =
  'update-video-player-needs-password';
export const UPDATE_VIDEO_PLAYER_NOT_WAITING =
  'update-video-player-not-waiting';
export const UPDATE_VIDEO_PLAYER_OWNER = 'update-video-player-owner';
export const UPDATE_VIDEO_PLAYER_PARENT_LOCATION =
  'update-video-player-parent-location';
export const UPDATE_VIDEO_PLAYER_PASSWORD = 'update-video-player-password';
export const UPDATE_VIDEO_PLAYER_PAUSED = 'update-video-player-paused';
export const UPDATE_VIDEO_PLAYER_PLAY = 'update-video-player-play';
export const UPDATE_VIDEO_PLAYER_PLAYBACK_RATE =
  'update-video-player-playback-rate';
export const UPDATE_VIDEO_PLAYER_PLAYING = 'update-video-player-playing';
export const UPDATE_VIDEO_PLAYER_POSTER_URL = 'update-video-player-poster-url';
export const UPDATE_VIDEO_PLAYER_SEEKING = 'update-video-player-seeking';
export const UPDATE_VIDEO_PLAYER_SOURCE = 'update-video-player-source';
export const UPDATE_VIDEO_PLAYER_SOURCE_FROM_CLIP =
  'update-video-player-source-from-clip';
export const UPDATE_VIDEO_PLAYER_PLAIN_SOURCE_URL =
  'update-video-player-plain-source-url';
export const UPDATE_VIDEO_PLAYER_THEATER_MODE =
  'update-video-player-theater-mode';
export const UPDATE_VIDEO_PLAYER_UNMUTE = 'update-video-player-unmute';
export const UPDATE_VIDEO_PLAYER_VIDEO = 'update-video-player-video';
export const UPDATE_VIDEO_PLAYER_VOLUME = 'update-video-player-volume';
export const UPDATE_VIDEO_PLAYER_WAITING = 'update-video-player-waiting';
export const UPDATE_VIDEO_VIEWER_NEEDS_PERMISSION =
  'update-video-viewer-needs-permission';
export const UPDATE_PIP_SUPPORTED = 'update-pip-supported';
export const UPDATE_CHROME_PIP_ENABLED = 'update-chrome-pip-enabled';
export const UPDATE_SAFARI_PIP_ENABLED = 'update-safari-pip-enabled';
export const UPDATE_VIDEO_DESCRIPTION = 'update-video-description';
export const UPDATE_VIDEO_PLAYER_NAME = 'update-video-player-name';
export const UPDATE_VIDEO_PROCESSING_ERROR = 'update-video-processing-error';
export const MERGE_VIDEO_PROCESSING_INFORMATION =
  'merge-video-processing-information';
export const UPDATE_VIDEO_PLAYER_PLAYING_PAUSED =
  'update-video-player-play-paused';
export const RESET_TRANSCRIPT_STATE = 'reset-transcript-state';
export const UPDATE_TRANSCRIPT_VISIBLE = 'update-transcript-visible';
export const UPDATE_TRANSCRIPT_STATUS = 'update-transcript-status';
export const UPDATE_TRANSCRIPT_DETAILS = 'update-transcript-details';
export const UPDATE_TRANSCRIPT_VERSION = 'update-transcript-version';
export const TOGGLE_IS_TRANSCRIPT_SEARCH_OPEN =
  'update-transcript-is-searching';
export const UPDATE_TRANSCRIPT_SEARCH_PHRASE =
  'update-transcript-search-phrase';
export const UPDATE_TRANSCRIPT_SEARCH_INPUT_VALUE =
  'update-transcript-search-input-value';
export const UPDATE_TRANSCRIPT_SEARCH_PHRASE_INDEX_ARRAY =
  'update-transcript-search-phrase-index-array';
export const UPDATE_CURRENT_SEARCH_INDEX = 'update-current-search-index';
export const UPDATE_TRANSCRIPT_PANEL_MODE = 'update-transcript-panel-mode';
export const VIDEO_READY_TO_PLAY_ON_SHARE_PAGE =
  'video-ready-to-play-on-share-page';
export const UPDATE_USER_HAS_OPENED_TRANSCRIPT =
  'update-user-has-opened-transcript';
export const UPDATE_VIDEO_FRAME_HEIGHT = 'update-video-frame-height';
export const UPDATE_CAPTIONS_DETAILS = 'update-captions-details';
export const SET_CURRENT_CAPTION = 'set-current-caption';
export const UPDATE_CAPTIONS_VISIBLE = 'update-captions-visible';
export const UPDATE_TRANSCRIPT_STATUS_ON_PLAYER =
  'update-transcript-status-on-video-player';
export const UPDATE_FILLER_WORDS = 'update-filler-words';
export const UPDATE_FILLER_WORD_HIGHLIGHT = 'update-filler-word-highlight';
export const UPDATE_IS_TRIMMING_FILLER_WORDS =
  'update-is-trimming-filler-words';
export const UPDATE_WAVEFORM_GENERATION_DETAILS =
  'update-waveform-generation-details';
export const UPDATE_WAVEFORM_GENERATION_STATUS =
  'update-waveform-generation-status';

// Emoji reactions
export const UPDATE_VIDEO_PLAYER_EMOJI_BAR_HIDE_REACTION =
  'update-video-player-emoji-bar-hide-reaction';
export const UPDATE_VIDEO_PLAYER_LOCAL_REACTIONS =
  'update-video-player-local-reactions';
export const UPDATE_VIDEO_PLAYER_REACTIONS_LOADED =
  'UPDATE_VIDEO_PLAYER_REACTIONS_LOADED';
export const UPDATE_VIDEO_PLAYER_REACTIONS_REMOVE =
  'UPDATE_VIDEO_PLAYER_REACTIONS_REMOVE';
export const VIDEO_PLAYER_EMOJI_SELECTED = 'video-player-emoji-selected';
export const VIDEO_PLAYER_EMOJI_SELECTED_RESET =
  'video-player-emoji-selected-reset';
export const VIDEO_PLAYER_EMOJI_SELECTED_SAVED =
  'video-player-emoji-selected-saved';
export const UPDATE_VIDEO_PLAYER_VOLUME_CONTROL_ACTIVE =
  'update-video-player-volume-control-active';
export const EMOJI_CLICKED_IN_VIDEO_PLAYER = 'emoji-clicked-in-video-player';

// welcome reducer
export const UPDATE_EDUCATION_TYPE = 'update-education-type';
export const UPDATE_OTHER_USE_CASE = 'update-other-use-case';
export const UPDATE_USE_CASES = 'update-use-cases';
export const UPDATE_WELCOME = 'update-welcome';
export const UPDATE_WELCOME_COMPANY = 'update-welcome-company';
export const UPDATE_WELCOME_COMPANY_SIZE = 'update-welcome-company-size';
export const UPDATE_WELCOME_COMPLETE = 'update-welcome-complete';
export const UPDATE_WELCOME_INDUSTRY = 'update-welcome-industry';
export const UPDATE_WELCOME_ROLE = 'update-welcome-role';
export const UPDATE_WELCOME_MANAGEMENT_LEVEL =
  'update-welcome-management-level';
export const UPDATE_WELCOME_STEP = 'update-welcome-step';
export const UPDATE_WELCOME_USE_CASE_PLAN = 'update-welcome-use-case-plan';
export const UPDATE_WELCOME_HELP_OPTIONS = 'update-welcome-help-options';

// JTBD reducer
export const FETCH_JTBD_FOLDERS_VIDEOS = 'fetch-jtbd-folders-videos';
export const UPDATE_JTBD_ARCHIVED = 'update-jtbd-archived';
export const UPDATE_JTBD_CONTENT = 'update-jtbd-content';
export const UPDATE_JTBD_DELETED = 'update-jtbd-deleted';
export const UPDATE_JTBD_FOLDERS_VIDEOS = 'update-jtbd-folders-videos';
export const UPDATE_JTBD_WATCHED = 'update-jtbd-watched';

// share video reducer
export const HIDE_FOLDER_HIERARCHY = 'hide-folder-hierarchy';
export const SHARE_VIDEO_MOVE_SUCCESS = 'share-video-move-success';
export const SHOW_FOLDER_HIERARCHY = 'show-folder-hierarchy';
export const UPDATE_CURRENT_USER_IS_OWNER = 'update-current-user-is-owner';
export const UPDATE_SHARE_VIDEO = 'update-share-video';
export const UPDATE_SHARE_VIDEO_NAME = 'update-share-video-name';
export const UPDATE_SHARE_VIDEO_DOWNLOAD_URL =
  'update-share-video-download-url';
export const UPDATE_SHARE_VIDEO_IFRAME_LOADED =
  'update-share-video-iframe-loaded';
export const UPDATE_SHARE_VIDEO_IN_TRIM_MODE =
  'update-share-video-in-trim-mode';
export const UPDATE_SHARE_VIDEO_PASSWORD = 'update-share-video-password';
export const UPDATE_SHARE_VIDEO_PLAYER_READY =
  'update-share-video-player-ready';
export const UPDATE_SHARE_VIDEO_SHOW_REMOVE_MODAL = 'update-show-remove-modal';
export const UPDATE_VIDEO_CTA = 'update-video-cta';
export const UPDATE_VIDEO_CTA_ENABLED = 'update-video-cta-enabled';
export const UPDATE_VIDEO_CTA_MODS = 'update-video-cta-mods';
export const UPDATE_VIDEO_CTA_SHOW = 'update-video-cta-show';
export const UPDATE_VIDEO_CTA_TEXT = 'update-video-cta-text';
export const UPDATE_VIDEO_CTA_URL = 'update-video-cta-url';
export const UPDATE_VIDEO_CTA_MODAL_SHOW = 'update-video-cta-modal-show';
export const UPLOAD_VIDEO_PROGRESS = 'upload-video-progress';
export const UPDATE_SHARE_VIDEO_IN_UPLOAD_MODE =
  'update-share-video-in-upload-mode';
export const UPDATE_VIDEO_PLAYER_IN_COMMENT_MODE =
  'update-video-player-in-comment-mode';
export const UPDATE_VIDEO_PLAYER_IN_ANONYMOUS_REACTION_MODE =
  'update-video-player-in-anonymous-reaction-mode';
export const UPDATE_VIDEO_PLAYER_BUCKET_ID = 'update-video-player-bucket-id';
export const UPDATE_VIDEO_PLAYER_SHOW_COMMENTS =
  'update-video-player-show-comments';

export const UPDATE_VIDEO_IFRAME_VISIBLITY = 'update-video-iframe-visibility';
export const UPDATE_VIDEO_SHARE_ALIAS = 'update-video-share-alias';
export const UPDATE_VIDEO_SHARE_SFDC_MODAL_SHOW =
  'update-video-share-sfdc-modal-show';

// share screenshot reducer
export const UPDATE_SHARE_SCREENSHOT = 'update-share-screenshot';
export const UPDATE_SHARE_SCREENSHOT_URL = 'update-share-screenshot-url';
export const UPDATE_SCREENSHOT_COMPLETE = 'update-screenshot-complete';

// move modal new folder actions
export const CREATE_NEW_FOLDER_FAILED = 'create-new-folder-failed';
export const CREATE_NEW_FOLDER_HIDE = 'create-new-folder-hide';
export const CREATE_NEW_FOLDER_LOAD = 'create-new-folder-load';
export const CREATE_NEW_FOLDER_SHOW = 'create-new-folder-show';
export const CREATE_NEW_FOLDER_SUCCESS = 'create-new-folder-success';
export const CREATE_NEW_FOLDER_UPDATE_NAME = 'create-new-folder-update-name';

export const SHARE_FOLDER_SHOW_MODAL = 'share-folder-show-modal';
export const SHARE_FOLDER_LOADING = 'share-folder-loading';
export const SHARE_FOLDER_HIDE_MODAL = 'hide-share-folder-modal';
export const SHARE_FOLDER_SUCCESS = 'share-folder-success';
export const SHARE_FOLDER_FAILED = 'share-folder-failed';

export const UNSHARE_FOLDER_LOADING = 'unshare-folder-loading';
export const UNSHARE_FOLDER_SUCCESS = 'unshare-folder-success';
export const UNSHARE_FOLDER_FAILED = 'unshare-folder-failed';

export const UPDATE_CAPABILITY = 'update-capability';
// slack info reducers
export const UPDATE_SLACK_INFO = 'update-slack-info';
export const START_SLACK_FETCH = 'start-slack-fetch';
export const END_SLACK_FETCH = 'end-slack-fetch';

export const FOLDER_DESCRIPTION_EDITING = 'folder-description-editing';
export const FOLDER_DESCRIPTION_CHANGED = 'folder-description-changed';
export const FOLDER_DESCRIPTION_EDITED = 'folder-description-edited';

// login reducers
export const UPDATE_LOGIN_EMAIL_ERROR = 'update-login-email-error';
export const UPDATE_LOGIN_IS_FETCHING = 'update-login-is-fetching';
export const UPDATE_LOGIN_PASSWORD_ERROR = 'update-login-password-error';
export const UPDATE_LOGIN_PLAIN_ERROR = 'update-login-plain-error';
export const UPDATE_LOGIN_OR_SIGN_UP = 'update-login-or-sign-up';
export const UPDATE_NEW_OAUTH = 'update-new-oauth';
export const TOGGLE_EMAIL_STEP = 'toggle-email-step';

// reset password reducers
export const UPDATE_RESET_PASSWORD_IS_FETCHING =
  'update-reset-password-is-fetching';

// comments reducers
export const FETCH_COMMENTS = 'fetch-comments';
export const UPDATE_ADD_COMMENT_ERROR = 'update-add-comment-error';
export const UPDATE_ADD_REPLY_ERROR = 'update-add-reply-error';
export const UPDATE_ADD_REPLY_ID = 'update-add-reply-id';
export const UPDATE_ANON_USER_NAME = 'update-anon-username';
export const UPDATE_COMMENTS = 'update-comments';
export const UPDATE_COMMENTS_TIMESTAMP = 'update-comments-timestamp';
export const UPDATE_COMMENTS_TIMESTAMP_FROZEN =
  'update-comments-timestamp-frozen';
export const UPDATE_EXPANDED_REPLY_IDS = 'update-expanded-reply-ids';
export const UPDATE_FETCHING_COMMENTS_ERROR = 'update-fetching-comments-error';
export const UPDATE_IN_GUEST_FLOW = 'update-in-guest-flow';
export const UPDATE_IN_GUEST_FLOW_REPLY = 'update-in-guest-flow-reply';
export const UPDATE_IS_FETCHING = 'update-is-fetching';
export const UPDATE_COMMENT_BUCKETS = 'update-comment-buckets';
export const UPDATE_COMMENT_REPLY_COUNT = 'update-comment-reply-count';

// onboarding
export const ONBOARDING_SENDING_EMAIL = 'onboarding-sending-email';
export const ONBOARDING_TOUR_COMPLETED = 'onboarding-tour-completed';
export const ONBOARDING_UDPATE = 'onboarding-update';

// avatars
export const UPDATE_AVATARS = 'update-avatars';
export const BEGIN_AVATAR_DRAG = 'begin-avatar-drag';
export const FINISH_AVATAR_DRAG = 'finish-avatar-drag';
export const START_AVATAR_UPLOAD = 'start-avatar-upload';
export const END_AVATAR_UPLOAD = 'end-avatar-upload';

// company features
export const UPDATE_COMPANY_FEATURE_DATA = 'update-company-feature-data';

// editor
export const START_CUSTOM_THUMBNAIL_FLOW = 'start-custom-thumbnail-flow';
export const END_CUSTOM_THUMBNAIL_FLOW = 'end-custom-thumbnail-flow';
export const START_CTA_FLOW = 'start-cta-flow';
export const END_CTA_FLOW = 'end-cta-flow';
export const START_VIDEO_SETTINGS_FLOW = 'start-video-settings-flow';
export const END_VIDEO_SETTINGS_FLOW = 'end-video-settings-flow';
export const SET_LOCAL_THUMBNAIL = 'set-local-thumbnail';
export const INITIATE_THUMBNAIL_SAVE = 'initiate-thumbnail-save';
export const TOGGLE_THUMBNAIL_UPLOADING = 'toggle-thumbnail-uploading';
export const FINISH_THUMBNAIL_SAVE = 'finish-thumbnail-save';

// homepage reducer
export const SHOW_CONNECT_BUTTONS = 'show-connect-buttons';

// feature flag reducer
export const UPDATE_BULK_FEATURE_FLAG_VALUES =
  'update-bulk-feature-flag-values';
export const UPDATE_FEATURE_FLAG_VALUE = 'update-feature-flag-value';
export const BEGIN_FEATURE_FLAG_FETCH = 'begin-feature-flag-fetch';
export const END_FEATURE_FLAG_FETCH = 'end-feature-flag-fetch';

// attachments reducer
export const FETCH_ALL_ATTACHMENTS = 'fetch-all-attachments';
export const UPDATE_ALL_ATTACHMENTS = 'update-all-attachments';
export const UPDATE_ATTACHMENT_INPUT_SELECTION_ERROR =
  'update-attachment-input-selection-error';
export const UPDATE_ATTACHMENT_WIDGET_ACTIVE =
  'update-attachment-widget-active';
export const UPDATE_ATTACHMENT_UPLOAD_ERROR = 'update-attachment-upload-error';
export const UPDATE_ATTACHMENT_UPLOAD_PROGRESS =
  'update-attachment-upload-progress';
export const UPDATE_ATTACHMENT_UPLOAD_QUEUE = 'update-attachment-upload-queue';
export const UPDATE_ATTACHMENT_UPLOAD_QUEUE_CURRENT_JOB_INDEX =
  'update-attachment-upload-queue-current-job-index';
export const UPDATE_ATTACHMENT_UPLOAD_QUEUE_TOTAL_JOBS =
  'update-attachment-upload-queue-total-jobs';
export const UPDATE_CREATE_ATTACHMENT_WITH_TIMESTAMP =
  'update-create-attachment-with-timestamp';

// preview panel reducer
export const TOGGLE_DETAILS_LOADING_STATUS = 'toggle-details-loading-status';
export const TOGGLE_FAVORITE_STATUS = 'toggle-favorite-status';
export const UPDATE_FOLDER_PREVIEW_DETAILS = 'update-folder-preview-details';
export const UPDATE_PREVIEW_FOLDER_SHARE_STATUS =
  'update-preview-folder-share-status';

// workspace reducer
export const POPULATE_WORKSPACES = 'populate-workspaces';
export const UPDATE_WORKSPACE_DETAILS = 'update-workspace-details';
export const TOGGLE_SELECT_WORKSPACE_MODAL = 'toggle-select-workspace-modal';
export const SET_PENDING_WORKSPACE_INVITES = 'set-pending-workspce-invites';
export const SET_FETCHING_WORKSPACE_ADMINS = 'set-fetching-admins';
export const UPDATE_WORKSPACE_ADMINS = 'update-admins';
export const UPDATE_UNSEEN_NOTIFICATIONS = 'update-unseen-notifications';

export const TOGGLE_LOOM_DOWNLOAD_MODAL = 'toggle-loom-download-modal';
export const TOGGLE_RECORD_TO_NON_DEFAULT_WORKSPACE_MODAL =
  'toggle-record-to-non-default-workspace-modal';

// modal actions
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// split screen takeover actions
export const OPEN_SPLIT_SCREEN_TAKEOVER = 'open-split-screen-takeover';
export const CLOSE_SPLIT_SCREEN_TAKEOVER = 'close-split-screen-takeover';

// layout actions
export const UPDATE_NAVIGATION_COLLAPSED = 'update-navigation-collapsed';
export const UPDATE_SHOW_INVITE_TEAMMATE_TOOLTIP =
  'update_show_invite_teammate_tooltip';

// video share modal actions
export const TOGGLE_FIRST_VIDEO_SHARE_MODAL = 'toggle-first-video-share-modal';

// upgrade actions
export const SET_UPGRADE_REQUESTED = 'set-upgrade-requested';
export const SET_UPGRADE_REQUESTED_FETCHING = 'set-upgrade-requested-fetching';
